<template>
    <div class="must-have-exactly-one-root-element">

        <!-- Header -->
        <header-profil
            @updateProfil="emitUpdateProfil"
            :profil="profil"
        />

        <!-- Main -->
        <main class="profileDashboard">
            <div class="container">
                <div class="row">

                    <!-- Menu -->
                    <menu-profil
                        :profil="profil"
                        :spravy="spravy"
                    />

                    <!-- Údaje používateľa -->
                    <div v-if="profil.pouzivatel_id" class="col-xs-12 col-md-12 col-lg-8 col-xl-9">
                        <h2>Moje údaje</h2>

                        <!-- Alert box -->
                        <div v-if="responseText != ''" :class="'alert alert-'+responseType" role="alert">
                            <span :class="'icon --'+responseType"></span>{{ responseText }}
                        </div>

                        <!-- Form Box -->
                        <form @submit="formSubmit">
                            <!-- Meno + Email -->
                            <div class="form-row">
                                <div class="col-12 col-md-6">
                                    <label for="meno">Meno</label>
                                    <input type="text" class="form-control" v-model="meno">
                                </div>
                                <div class="col-12 col-md-6">
                                    <label for="email">E-mail</label>
                                    <input type="email" class="form-control" v-model="email" readonly>
                                </div>
                            </div>

                            <!-- Okres -->
                            <div class="form-row">
                                <div class="col-12 col-md-6">
                                    <label>Okres</label>
                                    <select type="text" class="custom-select" @change="onChange($event.target.value)">
                                        <option v-for="item in okresy" :value="item.name" :selected="profil.pouzivatel_id.pouzivatel_okres == item.name ? 'selected' : ''">{{ item.name }}</option>
                                    </select>
                                </div>
                                <div class="col"></div>
                            </div>

                            <!-- Checkboxes -->
                            <div class="form-row">
                                <div class="col">
                                    <div class="custom-control custom-checkbox mb-2">
                                        <input type="checkbox" class="custom-control-input" id="customCheck1" v-model="suhlas1">
                                        <label class="custom-control-label" for="customCheck1">
                                            Súhlasím so zasielaním <strong>reklamných emailov</strong>.
                                        </label>
                                    </div>

                                    <div class="custom-control custom-checkbox mb-2">
                                        <input type="checkbox" class="custom-control-input" id="customCheck2" v-model="suhlas2">
                                        <label class="custom-control-label" for="customCheck2">
                                            Súhlasím so zasielaním <strong>informačných emailov</strong> z hry Adoptuj kravičku.
                                        </label>
                                    </div>

                                    <div class="custom-control custom-checkbox mb-2">
                                        <input type="checkbox" class="custom-control-input" id="customCheck3" v-model="suhlas3">
                                        <label class="custom-control-label" for="customCheck3">
                                            Súhlasím so zasielaním <strong>informačných emailov ohľadom stavu mojich kravičiek</strong> v hre Adoptuj kravičku.
                                        </label>
                                    </div>

                                    <div class="custom-control custom-checkbox mb-2">
                                        <input type="checkbox" class="custom-control-input" id="customCheck4" v-model="suhlas4">
                                        <label class="custom-control-label" for="customCheck4">
                                            Súhlasím so zaradením do <strong>verejných štatistík</strong> v hre (leader boardov).
                                        </label>
                                    </div>

                                    <div class="form-row">
                                        <button type="submit" class="btn --primary">
                                            Uložiť <span class="icon"></span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <!-- .Checkboxes -->
                        </form>
                        <!-- .Form Box -->
                    </div>
                    <!-- .Údaje používateľa -->

                </div>
            </div>
        </main>

    </div>
</template>



<script>
    import EventService from '@/services/EventService.js'
    import json         from '@/services/okresy.json'
    import HeaderProfil from '../partials/HeaderProfil.vue'
    import MenuProfil   from '../partials/MenuProfil.vue'
    export default {
        components: {
            HeaderProfil,
            MenuProfil
        },
        props: [
            'profil',
            'spravy'
        ],
        mounted() {
        },
        data() {
            return {
                setMeno: '',
                okres: '',
                okresy: json,

                responseType: '',
                responseText: ''
            }
        },
        computed: {
            email() {
                return this.profil.pouzivatel_email
            },
            meno: {
                get() { 
                    if (this.setMeno == '') {
                        return this.profil.pouzivatel_id.pouzivatel_name
                    }
                    return this.setMeno
                },
                set(set) { this.setMeno = set  }
            },
            suhlas1: {
                get() { return this.profil.pouzivatel_id.pouzivatel_suhlas_reklama },
                set(set) {  this.profil.pouzivatel_id.pouzivatel_suhlas_reklama = set }
            },
            suhlas2: {
                get() { return this.profil.pouzivatel_id.pouzivatel_suhlas_info },
                set(set) { this.profil.pouzivatel_id.pouzivatel_suhlas_info = set }
            },
            suhlas3: {
                get() { return this.profil.pouzivatel_id.pouzivatel_suhlas_info_kravicka },
                set(set) { this.profil.pouzivatel_id.pouzivatel_suhlas_info_kravicka = set }
            },
            suhlas4: {
                get() { return this.profil.pouzivatel_id.pouzivatel_suhlas_statistiky },
                set(set) { this.profil.pouzivatel_id.pouzivatel_suhlas_statistiky = set }
            },
        },
        methods: {
            // emit
            emitUpdateProfil() {
                this.$emit('updateProfil')
            },


            // select
            onChange(value) {
                this.okres = value
            },


            // submit
            formSubmit(e) {
                e.preventDefault()
                this.changePouzivatelInfo()
            },

            changePouzivatelInfo() {
                if (this.okres == '') { this.okres = this.profil.pouzivatel_id.pouzivatel_okres }
                if (this.setMeno == '') { this.setMeno = this.profil.pouzivatel_id.pouzivatel_name }
                EventService.changePouzivatelInfo(this.profil.pouzivatel_id.id, this.email, this.setMeno, this.okres, this.suhlas1, this.suhlas2, this.suhlas3, this.suhlas4)
                    .then(response => {
                        //console.log(response.data)
                        this.responseType = 'success'
                        this.responseText = 'Údaje boli úspešne zmenené'

                        this.profil.pouzivatel_id.pouzivatel_name = this.setMeno
                        this.$emit('update:profil', this.profil)
                    })
                    .catch(error => {
                        this.responseType = 'warning'
                        this.responseText = error
                    })
            }
        }
    }
</script>